import React, { useState, useEffect } from 'react'
import { Box, Paper, Loader, Text, Select, Flex } from '@mantine/core'
import { AreaChart } from '@mantine/charts'
import { getDataStatsSignUp } from '../../../services/dashboard'
import classes from '../../../assets/module-css/AdminLayout.module.css'

const defaultRangeStats = [
  {
    label: 'Daily',
    value: 'DAILY'
  },
  {
    label: 'Weekly',
    value: 'WEEKLY'
  },
  {
    label: 'Monthly',
    value: 'MONTHLY'
  },
]

const defaultRoleUser = [
  {
    label: 'All',
    value: 'ALL'
  },
  {
    label: 'Local Reseller',
    value: 'LOCAL_RESELLER'
  },
  {
    label: 'Local Reseller Plus',
    value: 'LOCAL_RESELLER_PLUS'
  },
  {
    label: 'Member Basic',
    value: 'MEMBER_BASIC'
  },
  {
    label: 'Member Premium',
    value: 'MEMBER_PREMIUM'
  },
  {
    label: 'Member VIP',
    value: 'MEMBER_VIP'
  },
]

const DashboardStatsUserGrowth = () => {
  const [loadingStatistic, setLoadingStatistic] = useState(true)
  const [statsSignUp, setStatsSignUp] = useState([])
  const [selectedRange, setSelectedRange] = useState('DAILY')
  const [selectedRole, setSelectedRole] = useState('ALL')

  const handleGetStatsSignUp = async () => {
    setLoadingStatistic(true)
    try {
      const response = await getDataStatsSignUp(selectedRole, selectedRange)
      if (response?.data) {
        const responseStats = response.data.userSignUpStats
        setStatsSignUp(responseStats)
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingStatistic(false)
    }
  }

  useEffect(() => {
    handleGetStatsSignUp()
    // eslint-disable-next-line
  }, [selectedRole, selectedRange])

  const loadingDataStats = () => {
    return (
      <Box ta='center' my={120}>
        <Loader size='sm' />
        <Text c='gray.6' fz={14}>Loading Data</Text>
      </Box>
    )
  }

  const loadLayoutStats = () => {
    return (
      <Box>
        <AreaChart
          h={250}
          data={statsSignUp}
          dataKey='label'
          series={[
            {
              name: 'count',
              label: 'User Signup',
              color: 'red'
            }
          ]}
          curveType="natural"
          tickLine="xy"
          gridAxis="xy"
        />
      </Box>
    )
  }


  return (
    <Paper shadow="sm" p='md' withBorder radius='md' my='lg'>
      <Text className={classes.titleLayout} mb='md'>User Growth</Text>
      <Flex gap='md' align='center'>
        <Box>
          <Select
            name='selectedRange'
            label="Based on Period"
            value={selectedRange}
            data={defaultRangeStats}
            onChange={setSelectedRange}
            size='xs'
            allowDeselect={false}
            w={150}
          />
        </Box>
        <Box>
          <Select
            name='selectedRole'
            label="Role"
            value={selectedRole}
            data={defaultRoleUser}
            onChange={setSelectedRole}
            size='xs'
            allowDeselect={false}
            w={180}
          />
        </Box>
      </Flex>
      <Box my={20}>
        {loadingStatistic ? loadingDataStats() : loadLayoutStats()}
      </Box>
    </Paper>
  )
}

export default DashboardStatsUserGrowth